/**
 * Do not edit directly
 * Generated on Mon, 07 Jun 2021 13:38:45 GMT
 */

export const BASE_BG_COLOR = 'rgba(98,101,107,1)';
export const BASE_BG_HOVER_COLOR = 'rgba(62,64,68,1)';
export const BASE_BG_LIGHT_COLOR = 'rgba(249,249,249,1)';
export const BASE_BORDER_COLOR = 'rgba(144,146,152,1)';
export const BASE_BORDER_WIDTH = '1px';
export const BASE_BORDER_RADIUS = '.25rem';
export const BASE_BORDER_HOVER_COLOR = 'rgba(98,101,107,1)';
export const BASE_TEXT_SIZE = '1rem';
export const BASE_TEXT_COLOR = 'rgba(98,101,107,1)';
export const BASE_TEXT_HOVER_COLOR = 'rgba(98,101,107,1)';
export const BASE_LINE_HEIGHT = '1.5';
export const BORDER_RADIUS_MD = '.25rem';
export const BORDER_RADIUS_SM = '.5rem';
export const BORDER_RADIUS_LG = '.75rem';
export const INPUT_BTN_HEIGHT_MD = '3rem';
export const INPUT_BTN_HEIGHT_SM = '2rem';
export const INPUT_BTN_HEIGHT_LG = '4rem';
export const INPUT_BTN_PADDING_X_MD = '1rem';
export const INPUT_BTN_PADDING_X_SM = '.5rem';
export const INPUT_BTN_PADDING_X_LG = '1.5rem';
export const INPUT_BG_COLOR = '#fff';
export const LABEL_FONT_WEIGHT = '600';
export const LABEL_FONT_SIZE = '1rem';
export const LABEL_MARGIN_BOTTOM = '.5rem';
export const TEXT_SIZE_XS = '.75rem';
export const TEXT_SIZE_SM = '.875rem';
export const TEXT_SIZE_MD = '1rem';
export const TEXT_SIZE_LG = '1.125rem';
export const TEXT_COLOR = 'rgba(23,24,25,1)';
export const TEXT_MUTED_COLOR = 'rgba(98,101,107,1)';
export const COLOR_BLUE_LIGHT_10 = 'rgba(215,247,255,1)';
export const COLOR_BLUE_LIGHT_20 = 'rgba(182,239,255,1)';
export const COLOR_BLUE_LIGHT_30 = 'rgba(146,231,255,1)';
export const COLOR_BLUE_LIGHT_40 = 'rgba(74,193,255,1)';
export const COLOR_BLUE_LIGHT_50 = 'rgba(0,133,202,1)';
export const COLOR_BLUE_LIGHT_60 = 'rgba(0,80,121,1)';
export const COLOR_BLUE_LIGHT_70 = 'rgba(0,49,74,1)';
export const COLOR_BLUE_LIGHT_80 = 'rgba(0,30,45,1)';
export const COLOR_BLUE_LIGHT_90 = 'rgba(3,18,25,1)';
export const COLOR_BLUE_LIGHT_05 = 'rgba(242,251,255,1)';
export const COLOR_BLUE_10 = 'rgba(226,240,251,1)';
export const COLOR_BLUE_20 = 'rgba(207,229,247,1)';
export const COLOR_BLUE_30 = 'rgba(176,209,236,1)';
export const COLOR_BLUE_40 = 'rgba(137,180,214,1)';
export const COLOR_BLUE_50 = 'rgba(92,147,191,1)';
export const COLOR_BLUE_60 = 'rgba(47,115,169,1)';
export const COLOR_BLUE_70 = 'rgba(0,75,135,1)';
export const COLOR_BLUE_80 = 'rgba(0,43,77,1)';
export const COLOR_BLUE_90 = 'rgba(0,14,25,1)';
export const COLOR_BLUE_05 = 'rgba(243,250,255,1)';
export const COLOR_GRAY_10 = 'rgba(236,237,238,1)';
export const COLOR_GRAY_20 = 'rgba(221,222,224,1)';
export const COLOR_GRAY_30 = 'rgba(202,205,213,1)';
export const COLOR_GRAY_40 = 'rgba(180,181,185,1)';
export const COLOR_GRAY_50 = 'rgba(144,146,152,1)';
export const COLOR_GRAY_60 = 'rgba(98,101,107,1)';
export const COLOR_GRAY_70 = 'rgba(62,64,68,1)';
export const COLOR_GRAY_80 = 'rgba(36,37,40,1)';
export const COLOR_GRAY_90 = 'rgba(23,24,25,1)';
export const COLOR_GRAY_05 = 'rgba(249,249,249,1)';
export const COLOR_GREEN_10 = 'rgba(213,247,232,1)';
export const COLOR_GREEN_20 = 'rgba(164,229,199,1)';
export const COLOR_GREEN_30 = 'rgba(104,196,153,1)';
export const COLOR_GREEN_40 = 'rgba(66,174,124,1)';
export const COLOR_GREEN_50 = 'rgba(34,152,97,1)';
export const COLOR_GREEN_60 = 'rgba(0,105,56,1)';
export const COLOR_GREEN_70 = 'rgba(5,58,33,1)';
export const COLOR_GREEN_80 = 'rgba(3,28,16,1)';
export const COLOR_GREEN_90 = 'rgba(1,10,6,1)';
export const COLOR_GREEN_05 = 'rgba(240,255,247,1)';
export const COLOR_ORANGE_10 = 'rgba(252,228,204,1)';
export const COLOR_ORANGE_20 = 'rgba(255,198,139,1)';
export const COLOR_ORANGE_30 = 'rgba(255,160,66,1)';
export const COLOR_ORANGE_40 = 'rgba(255,130,0,1)';
export const COLOR_ORANGE_50 = 'rgba(209,117,31,1)';
export const COLOR_ORANGE_60 = 'rgba(133,78,29,1)';
export const COLOR_ORANGE_70 = 'rgba(90,53,21,1)';
export const COLOR_ORANGE_80 = 'rgba(62,35,12,1)';
export const COLOR_ORANGE_90 = 'rgba(43,23,4,1)';
export const COLOR_ORANGE_05 = 'rgba(255,249,245,1)';
export const COLOR_WHITE = '#fff';
export const COLOR_BLACK = '#000';
export const COLOR_RED_10 = 'rgba(253,229,228,1)';
export const COLOR_RED_20 = 'rgba(251,204,201,1)';
export const COLOR_RED_30 = 'rgba(250,162,162,1)';
export const COLOR_RED_40 = 'rgba(254,126,126,1)';
export const COLOR_RED_50 = 'rgba(230,71,71,1)';
export const COLOR_RED_60 = 'rgba(190,35,35,1)';
export const COLOR_RED_70 = 'rgba(147,22,22,1)';
export const COLOR_RED_80 = 'rgba(88,9,9,1)';
export const COLOR_RED_90 = 'rgba(24,2,2,1)';
export const COLOR_RED_05 = 'rgba(255,248,247,1)';
export const COLOR_VIOLET_10 = 'rgba(253,230,242,1)';
export const COLOR_VIOLET_20 = 'rgba(252,211,232,1)';
export const COLOR_VIOLET_30 = 'rgba(246,185,217,1)';
export const COLOR_VIOLET_40 = 'rgba(238,153,197,1)';
export const COLOR_VIOLET_50 = 'rgba(222,111,169,1)';
export const COLOR_VIOLET_60 = 'rgba(196,58,129,1)';
export const COLOR_VIOLET_70 = 'rgba(154,0,80,1)';
export const COLOR_VIOLET_80 = 'rgba(96,0,50,1)';
export const COLOR_VIOLET_90 = 'rgba(28,0,14,1)';
export const COLOR_VIOLET_05 = 'rgba(255,248,252,1)';
export const BREAKPOINT_XS = '0';
export const BREAKPOINT_SM = '640px';
export const BREAKPOINT_MD = '768px';
export const BREAKPOINT_LG = '1024px';
export const BREAKPOINT_XL = '1280px';
export const GRID_GAP_1 = '.125rem';
export const GRID_GAP_2 = '.25rem';
export const GRID_GAP_3 = '.5rem';
export const GRID_GAP_4 = '.75rem';
export const GRID_GAP_5 = '1rem';
export const GRID_GAP_6 = '1.125rem';
export const GRID_GAP_7 = '1.5rem';
export const GRID_GAP_8 = '2rem';
export const GRID_GAP_9 = '2.5rem';
export const GRID_GAP_10 = '3rem';
export const GRID_GAP_11 = '4rem';
export const ZINDEX_DROPDOWN = '1000';
export const ZINDEX_STICKY = '1020';
export const ZINDEX_FIXED = '1030';
export const ZINDEX_MODAL_BACKDROP = '1040';
export const ZINDEX_MODAL = '1050';
export const ZINDEX_POPOVER = '1060';
export const ZINDEX_TOOLTIP = '1070';
export const SPACER_1 = '.125rem';
export const SPACER_2 = '.25rem';
export const SPACER_3 = '.5rem';
export const SPACER_4 = '.75rem';
export const SPACER_5 = '1rem';
export const SPACER_6 = '1.125rem';
export const SPACER_7 = '1.5rem';
export const SPACER_8 = '2rem';
export const SPACER_9 = '2.5rem';
export const SPACER_10 = '3rem';
export const SPACER_11 = '4rem';
export const SPACER_12 = '6rem';
export const FONT_SIZE_1 = '.75rem';
export const FONT_SIZE_2 = '.875rem';
export const FONT_SIZE_3 = '1rem';
export const FONT_SIZE_4 = '1.125rem';
export const FONT_SIZE_5 = '1.25rem';
export const FONT_SIZE_6 = '1.5rem';
export const FONT_SIZE_7 = '1.75rem';
export const FONT_SIZE_8 = '2rem';
export const FONT_SIZE_9 = '2.25rem';
export const FONT_SIZE_10 = '3rem';
export const FONT_SIZE_11 = '3.75rem';
export const FONT_WEIGHT_LIGHT = '300';
export const FONT_WEIGHT_REGULAR = '400';
export const FONT_WEIGHT_BOLD = '600';
export const FONT_WEIGHT_BLACK = '900';
export const LINE_HEIGHT_SM = '1.2';
export const LINE_HEIGHT_MD = '1.5';
export const LINE_HEIGHT_LG = '1.6';
export const LINK_COLOR = 'rgba(47,115,169,1)';
export const LINK_DECORATION = 'none';
export const LINK_HOVER_COLOR = 'rgba(0,75,135,1)';
export const LINK_HOVER_DECORATION = 'underline';
export const BTN_BASE_TEXT_COLOR = 'rgba(23,24,25,1)';
export const BTN_BASE_TEXT_HOVER_COLOR = 'rgba(23,24,25,1)';
export const BTN_BASE_TEXT_ACTIVE_COLOR = 'rgba(47,115,169,1)';
export const BTN_BASE_BG_COLOR = '#fff';
export const BTN_BASE_BG_HOVER_COLOR = 'rgba(249,249,249,1)';
export const BTN_BASE_BORDER_COLOR = 'rgba(144,146,152,1)';
export const BTN_BASE_BORDER_HOVER_COLOR = 'rgba(98,101,107,1)';
export const BTN_BASE_BORDER_RADIUS = '.25rem';
export const BTN_BASE_FONT_WEIGHT = '400';
export const BTN_BASE_FONT_SIZE = '1rem';
export const BTN_LINK_TEXT_COLOR = 'rgba(47,115,169,1)';
export const BTN_LINK_TEXT_HOVER_COLOR = 'rgba(0,75,135,1)';
export const BTN_LINK_TEXT_ACTIVE_COLOR = 'rgba(47,115,169,1)';
export const BTN_LINK_BG_COLOR = 'transparent';
export const BTN_LINK_BG_HOVER_COLOR = 'rgba(249,249,249,1)';
export const BTN_LINK_BORDER_COLOR = 'transparent';
export const BTN_LINK_BORDER_HOVER_COLOR = 'transparent';
export const BTN_PRIMARY_TEXT_COLOR = '#fff';
export const BTN_PRIMARY_TEXT_HOVER_COLOR = '#fff';
export const BTN_PRIMARY_BG_COLOR = 'rgba(0,75,135,1)';
export const BTN_PRIMARY_BG_HOVER_COLOR = 'rgba(0,43,77,1)';
export const BTN_PRIMARY_BORDER_COLOR = 'rgba(0,75,135,1)';
export const BTN_PRIMARY_BORDER_HOVER_COLOR = 'rgba(0,75,135,1)';
export const BTN_SUCCESS_TEXT_COLOR = '#fff';
export const BTN_SUCCESS_TEXT_HOVER_COLOR = '#fff';
export const BTN_SUCCESS_BG_COLOR = 'rgba(0,105,56,1)';
export const BTN_SUCCESS_BG_HOVER_COLOR = 'rgba(5,58,33,1)';
export const BTN_SUCCESS_BORDER_COLOR = 'rgba(0,105,56,1)';
export const BTN_SUCCESS_BORDER_HOVER_COLOR = 'rgba(5,58,33,1)';
export const BTN_DANGER_TEXT_COLOR = '#fff';
export const BTN_DANGER_TEXT_HOVER_COLOR = '#fff';
export const BTN_DANGER_BG_COLOR = 'rgba(190,35,35,1)';
export const BTN_DANGER_BG_HOVER_COLOR = 'rgba(147,22,22,1)';
export const BTN_DANGER_BORDER_COLOR = 'rgba(190,35,35,1)';
export const BTN_DANGER_BORDER_HOVER_COLOR = 'rgba(190,35,35,1)';
export const PRIMARY_BG_COLOR = 'rgba(0,75,135,1)';
export const PRIMARY_BG_HOVER_COLOR = 'rgba(0,43,77,1)';
export const PRIMARY_BG_LIGHT_COLOR = 'rgba(243,250,255,1)';
export const PRIMARY_TEXT_COLOR = 'rgba(47,115,169,1)';
export const PRIMARY_BORDER_COLOR = 'rgba(0,75,135,1)';
export const PRIMARY_BORDER_HOVER_COLOR = 'rgba(0,43,77,1)';
export const SUCCESS_BG_COLOR = 'rgba(0,105,56,1)';
export const SUCCESS_BG_HOVER_COLOR = 'rgba(5,58,33,1)';
export const SUCCESS_BG_LIGHT_COLOR = 'rgba(240,255,247,1)';
export const SUCCESS_TEXT_COLOR = 'rgba(0,105,56,1)';
export const SUCCESS_BORDER_COLOR = 'rgba(0,105,56,1)';
export const SUCCESS_BORDER_HOVER_COLOR = 'rgba(5,58,33,1)';
export const DANGER_BG_COLOR = 'rgba(190,35,35,1)';
export const DANGER_BG_HOVER_COLOR = 'rgba(147,22,22,1)';
export const DANGER_BG_LIGHT_COLOR = 'rgba(255,248,247,1)';
export const DANGER_TEXT_COLOR = 'rgba(190,35,35,1)';
export const DANGER_BORDER_COLOR = 'rgba(190,35,35,1)';
export const DANGER_BORDER_HOVER_COLOR = 'rgba(147,22,22,1)';
export const TAB_BASE_TEXT_COLOR = 'rgba(98,101,107,1)';
export const TAB_BASE_BORDER_COLOR = 'rgba(144,146,152,1)';
export const TAB_BASE_BORDER_WIDTH = '1px';
export const TAB_BASE_BORDER_ACTIVE_COLOR = 'rgba(0,75,135,1)';
export const TAB_BASE_BORDER_ACTIVE_WIDTH = '.125rem';
export const TAB_BASE_BG_HOVER_COLOR = 'rgba(243,250,255,1)';
export const TAB_BASE_BG_ACTIVE_COLOR = 'rgba(243,250,255,1)';
export const TAB_BASE_HEIGHT = '3rem';
export const TAB_BASE_PADDING_X = '1rem';
export const TABS_BASE_BORDER_COLOR = 'rgba(144,146,152,1)';
export const TABS_BASE_BORDER_WIDTH = '1px';
export const HEADING_COLOR = 'rgba(23,24,25,1)';
export const HEADING_MARGIN_TOP = '0';
export const HEADING_MARGIN_BOTTOM = 'calc(1rem / 2)';
export const HEADING_FONT_FAMILY =
	"Inter, arial, 'Helvetica Neue', helvetica, sans-serif";
export const HEADING_FONT_WEIGHT = '900';
export const HEADING_LINE_HEIGHT = '1.2';
export const H1_SIZE = '2.25rem';
export const H1_WEIGHT = '900';
export const H2_SIZE = '1.75rem';
export const H2_WEIGHT = '900';
export const H3_SIZE = '1.5rem';
export const H3_WEIGHT = '900';
export const H4_SIZE = '1.25rem';
export const H4_WEIGHT = '900';
export const H5_SIZE = '1.125rem';
export const H5_WEIGHT = '900';
export const H6_SIZE = '1rem';
export const H6_WEIGHT = '900';
export const DISPLAY_SM = '3rem';
export const DISPLAY_MD = '3.75rem';
export const HR_COLOR = 'inherit';
export const HR_HEIGHT = '1px';
export const HR_OPACITY = '.25';
export const LIST_MARGIN_BOTTOM = '1.125rem';
export const DT_FONT_WEIGHT = '600';
export const FONT_FAMILY =
	"Inter, arial, 'Helvetica Neue', helvetica, sans-serif";
export const PARAGRAPH_MARGIN_BOTTOM = '1.5rem';
export const MARK_BG_COLOR = 'rgba(252,228,204,1)';
export const BODY_TEXT_COLOR = 'rgba(23,24,25,1)';
export const BODY_TEXT_SIZE = '1rem';
export const BODY_TEXT_WEIGHT = '400';
export const BODY_BG_COLOR = '#fff';
export const FOCUS_OULINE_COLOR = 'rgba(92,147,191,1)';
export const FOCUS_OULINE_WIDTH = '.125rem';
export const DISABLED_OPACITY = '.6';
